const convertMinutesToString = (value, midnight) => {

    var rawValue = parseInt(value)
    if(rawValue === "" || rawValue === undefined || rawValue === 0 || isNaN(rawValue)) {
        return "00:00"
    }
    if(midnight && rawValue > 1440) {
        rawValue = rawValue - 1440
    }
    var hours = Math.floor(rawValue  / 60 )
    var minutes = Math.round((rawValue/60 - hours) * 60)

    if(minutes<10) {
        minutes = "0" + minutes
    }
    
    var valueString = "" + hours + minutes
    if(valueString.length < 4) {
        while (valueString.length < 4) {
            valueString = "0" + valueString
        }
    }

    if(hours > 99) {
        return valueString[0] + valueString[1] + valueString[2] + ":" + valueString[3] + valueString[4]
    }

    return valueString[0] + valueString[1] + ":" + valueString[2] + valueString[3]

}

export default convertMinutesToString



// WEBPACK FOOTER //
// ./src/Components/convertMinutesToString.js